import React from 'react';
export function Footer() {
  return <footer className="bg-slate-950 py-8 sm:py-12 text-center text-xs sm:text-sm text-slate-500" data-id="element-70">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8" data-id="element-71">
        <p className="mb-3 sm:mb-4" data-id="element-72">
          © 2026 Stretching Ready — All Rights Reserved. Unauthorized
          reproduction and redistribution strictly prohibited.
        </p>
        <p className="text-[10px] sm:text-xs text-slate-600 max-w-2xl mx-auto" data-id="element-73">
          Our products and content are strictly educational and informational in
          nature. Individual results vary and depend entirely on the commitment,
          skills and personal application of each user.
        </p>
      </div>
    </footer>;
}